import type { InjectionKey } from 'vue';

export const SKIP_DASHBOARD_PALETTE_REVISION_KEY: InjectionKey<boolean> = Symbol('skipDashboardPaletteRevision');
